<template>
  <div class="popover" :class="setClassModifiers('popover--')">
    <div class="popover__activator"
         ref="popoverActivator"
         @mouseover="handleMouseOverShow()"
         @mouseleave="handleMouseOverHide()"
         @click="handleClickShowHide()"
    >
      <slot name="activator"></slot>
    </div>
    <transition name="fade">
      <div class="popover__container"
        v-if="computedShow"
        :style="`left: ${positionLeft}; top: ${positionTop}px; max-width: ${computedMaxWidth}px; right: ${positionRight}; max-height: ${maxHeight}; ${computedTransform}`"
        v-click-outside="handlePopoverHide"
        v-scrollable
      >
<!--        <div class="popover__triangle"><span class="popover__triangle-item"></span></div>-->
        <div class="popover__content">
<!--          <div class="popover__icon-close icon-close"></div>-->
          <div class="py-1 set-indent" v-if="$slots.header">
            <slot name="header"></slot>
          </div>

          <div :class="$slots.right ? 'popover__left' : null" style="width: 100%;">
            <slot name="default" :slot-props="{ positionTop }"></slot>
          </div>
        </div>

<!--        <div class="icon-close popover__close" v-if="type === 'dropdown'" @click="computedShow = false"></div>-->
      </div>
    </transition>
  </div>
</template>

<script>
import modalActivate from '@/mixins/modalActivate'
import setClassModifiers from '@/mixins/setClassModifiers'
import screen from '@/mixins/screen'

import clickOutside from '@/directives/clickOutside'
import scrollable from '@/directives/scrollable'

export default {
  name: 'popover',
  directives: {
    clickOutside,
    scrollable
  },
  data () {
    return {
      activatorHeight: 0,
      activatorOffsetTop: 0,
      activatorOffsetLeft: 0,
      activatorOffsetRight: 0,
      activatorWidth: 0,

      cursorStartX: 0,
      cursorCurrentX: 0,
      cursorStartY: 0,
      cursorCurrentY: 0,
      cursorDifference: 0,

      interval: null,
      count: 0,
      timeout: null,
      popoverTimeout: null
    }
  },

  props: {
    right: {
      type: Boolean,
      default: false
    },

    left: {
      type: Boolean,
      default: false
    },

    maxWidth: {
      type: Number,
      default: 320
    },

    noPadding: {
      type: Boolean,
      default: false
    },

    /**
     * @values popover, dropdown
     */
    type: {
      type: String,
      default: 'popover'
    },

    /**
     * @values light, dark
     */
    theme: {
      type: String,
      default: 'dark'
    },

    value: {
      type: Boolean,
      default: false
    },

    position: {
      type: String,
      default: 'absolute'
    }
  },

  mixins: [modalActivate, setClassModifiers, screen],

  computed: {
    computedShow: {
      get () {
        if (!this.value) {
          return this.show
        }

        return this.value
      },

      set (val) {
        this.show = val
        this.$emit('input', val)
      }
    },

    computedLeft () {
      if (this.computedPosition === 'left') {
        return this.activatorOffsetLeft + 'px'
      }

      if (this.computedPosition === 'right') {
        return 'unset'
      }

      return this.activatorOffsetLeft + (this.activatorWidth / 2) + 'px'
    },
    computedTop () {
      return this.activatorOffsetTop + this.activatorHeight + 1 + 'px'
    },

    computedPosition () {
      if (this.right || (this.activatorOffsetRight < (this.maxWidth / 2) - (this.activatorWidth / 2))) {
        return 'right'
      }

      if (this.left || (this.activatorOffsetLeft < (this.maxWidth / 2) - (this.activatorWidth / 2))) {
        return 'left'
      }

      return 'center'
    },

    positionTop () {
      return this.position === 'fixed' ? this.activatorHeight + this.activatorOffsetTop + 5 : this.activatorHeight + 5
    },

    positionLeft () {
      if (this.computedPosition === 'right') {
        return 'unset'
      }

      if (this.computedPosition === 'left' && this.position === 'fixed') {
        return this.activatorOffsetLeft + 'px'
      } else if (this.computedPosition === 'left') {
        return 0 + 'px'
      }

      return this.position === 'fixed' ? this.activatorOffsetLeft + (this.activatorWidth / 2) + 'px' : 0
    },

    computedTransform () {
      return this.computedPosition === 'left' || this.computedPosition === 'right' ? '' : 'transform: translateX(-50%)'
    },

    positionRight () {
      if (this.computedPosition !== 'right') {
        return 'unset'
      }

      return this.position === 'fixed' ? this.activatorOffsetRight + 'px' : 0 + 'px'
    },

    maxHeight () {
      return (this.screen.height - this.positionTop - 40) + 'px'
    },

    computedMaxWidth () {
      if (this.maxWidth > this.screen.width) {
        return this.screen.width
      }

      return this.maxWidth
    }

    // computedStyle () {
    //   `left: ${positionLeft}; top: ${positionTop}px; max-width: ${computedMaxWidth}px; right: ${positionRight}; max-height: ${maxHeight}`
    //   const out = {
    //     maxWidth: this.computedMaxWidth,
    //     maxHeight: this.maxHeight,
    //     positionLeft: this.positionLeft
    //   }
    //
    //   if (this.position === 'fixed') {
    //     out.positionLeft = this.positionLeft
    //   }
    //
    //   return out
    // }
  },

  methods: {
    handleMouseOverShow () {
      if (this.type !== 'dropdown') {
        clearTimeout(this.timeout)
        this.computedShow = true
      }
    },

    handleMouseOverHide () {
      if (this.type !== 'dropdown') {
        this.computedShow = false
      }
    },

    handleClickShowHide () {
      clearTimeout(this.popoverTimeout)
      setTimeout(() => {
        clearTimeout(this.popoverTimeout)
      }, 50)
      if (this.type === 'dropdown') {
        this.computedShow = !this.computedShow
      }
    },

    handlePopoverHide () {
      this.popoverTimeout = setTimeout(() => {
        if (this.computedShow) {
          this.computedShow = false
        }
      }, 100)
    },

    computeVerticalDimensions () {
      const elem = this.$refs.popoverActivator
      if (!elem) {
        return
      }
      const box = elem.getBoundingClientRect()
      this.activatorOffsetTop = box.top + pageYOffset
    },

    computeDimensions () {
      const elem = this.$refs.popoverActivator
      if (!elem) {
        return
      }
      const box = elem.getBoundingClientRect()
      const screenWidth = this.screen.width
      if (!elem) {
        return
      }
      this.activatorHeight = box.height
      this.activatorWidth = box.width
      this.activatorOffsetLeft = box.left + pageXOffset
      this.activatorOffsetRight = screenWidth - (box.left + pageXOffset) - box.width
    }
  },

  mounted () {
    this.interval = setInterval(() => {
      this.computeDimensions()
      this.computeVerticalDimensions()
      this.count = this.count + 200
      if (this.count >= 2000) {
        clearInterval(this.interval)
      }
    }, 200)
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  watch: {
    'screen.height' () {
      this.computeVerticalDimensions()
    },
    'screen.width' () {
      this.computeDimensions()
    }
  }
}
</script>

<style lang="scss">
  .popover {
    display: inline-block;
    position: relative;

    &__activator {
      /*display: inline-block;*/
      /*padding-top: 2px;*/
    }

    &--center {
      .popover__container {
        transform: translateX(-50%);
      }
    }

    &--right {
      .popover__container {
        /*right: 0;*/
/*        transform: translateX(10%);*/
      }
      .popover__triangle-item {
        margin-right: 13px;
      }
    }

    &--left {
      .popover__container {
        /*transform: translateX(-9.5%);*/
      }

      .popover__triangle-item {
        margin-left: 13px;
      }
    }

    &__triangle {
      position: relative;
    }

    &__triangle-item {
      display: block;
      margin: 0 auto;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 .5rem .5rem .5rem;
      border-color: transparent transparent $color-white transparent;
    }

    &--dark {
      .popover__triangle-item {
        border-color: transparent transparent rgba($color-secondary, .9) transparent;
      }
    }

    &__close {
      position: absolute;
      right: 1rem;
      top: 1rem;
      font-size: 1.4rem;
      color: $color-space;
      cursor: pointer;
    }

    &__container {
      position: absolute;
      z-index: 999;
      min-width: 24rem;
      overflow-y: auto;
      background-color: $color-white;
      box-shadow: $elevation-darken;
      border-radius: $border-radius;
    }

    &--fixed {
      .popover__container {
        position: fixed
      }
    }

    &__content {
      padding: 2.5rem;
      display: flex;
      justify-content: flex-start;
    }

    &--dark {
      .popover__container {
        background-color: rgba($color-secondary, .9);
        color: $color-white;
      }
    }

    &__icon-close {
      position: absolute;
      top: 1.5rem;
      right: 1.5rem;
    }

    &--no-padding {
      .popover__content {
        padding: 0
      }
    }
  }
</style>
